import React from 'react';
import { Spinner } from 'react-bootstrap';
import { useAppSelector } from 'store/hooks';
import { loader } from 'store/selectors';
import loaderGif from '../../assets/images/loader.gif';

interface Props {
  type?: string
}

const Loader: React.FC<Props> = ({ type }) => {

  const loaderSelector = useAppSelector(loader(type));

  if (loaderSelector) {
    return (
      <div className={`loader ${type ? 'absolute' : ''}`}>
        <div className="loader_img">
          {type ? (
            <Spinner animation="border" variant="dark" />
          ) : (
            <img alt="Loader" src={loaderGif} width={60} />
          )}
        </div>
      </div>
    );
  } else {
    return null;
  }

}


export default Loader;
